import { BaseNavbar } from '@/components/layouts/base-navbar';

/**
 * Settings Navbar
 * No settings icon (already in settings section) and uses sticky positioning
 */
export function SettingsNavbar() {
  return <BaseNavbar headerStyle="sticky" />;
}
